var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"realtime-quote-view"},[_c('RealtimeQuoteWS')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }